import List from '../../containers/Payments/List';
import Edit from '../../containers/Payments/Edit';
import Create from '../../containers/Payments/Create';
import Show from '../../containers/Payments/Show';

export default { List, Edit, Create, Show };
